import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(products)/product/[slug]/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomContextProvider"] */ "/vercel/path0/src/contexts/contextCreator.tsx");
